module.exports = __webpack_public_path__ + "img/at (6).c4f66b4d.jpg";